module.exports = __webpack_public_path__ + "img/login_logo.2c40f98b.png";